module.exports = "/images/CE.png?d6036c2cceb91413b7497d89ac9b3648";